module.exports = __webpack_public_path__ + "static/bello-419127d27867e001423ba69dc034addb.png";